import cn from 'classnames/bind';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ErrorFallbackProps } from '@funtech-int/rival-react';

import { Button } from '@/shared/components/Button/Button';
import { withResourceFreeError } from '@/shared/components/WithResourceFreeError/withResourceFreeError';

import styles from './LoadingProgramError.module.css';

const cx = cn.bind(styles);

export const LoadingProgramErrorComponent: FC<ErrorFallbackProps> = withResourceFreeError(
    ({ resetError }) => (
        <div className={cx('root')}>
            <div className={cx('icon')} />
            <span className={cx('text')}>
                <FormattedMessage
                    id="features.channel-program.fe4245663904638b69996efcf4c11046"
                    defaultMessage="An error occurred when loading TV listings. Please try again."
                    description="Текст ошибки при загрузке телепрограммы"
                />
            </span>
            <Button variant="accent" size={48} onClick={resetError}>
                <FormattedMessage
                    id="features.channel-program.63a6a88c066880c5ac42394a22803ca6"
                    defaultMessage="Refresh"
                    description="Текст кнопки перезагрузки телепрограммы"
                />
            </Button>
        </div>
    )
);
